import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";
export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="flex min-h-screen bg-slate-900">
      {/* Left brand panel */}
      <div className="relative hidden w-1/2 flex-col justify-between overflow-hidden bg-slate-900 p-12 lg:flex">
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
            backgroundSize: "42px 42px",
          }}
        />
        <div className="relative flex items-center gap-3">
          <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-lg bg-white p-1.5 ring-1 ring-white/10">
            <img src="/logo.png" alt="ONT" className="h-full w-full object-contain" />
          </div>
          <div>
            <p className="font-heading text-lg font-bold text-white">ONT — RDC</p>
            <p className="text-xs uppercase tracking-[0.16em] text-slate-400">Fonds de Promotion du Tourisme</p>
          </div>
        </div>
        <div className="relative">
          <h1 className="font-heading text-4xl font-bold leading-tight text-white">
            Office National<br />du Tourisme
          </h1>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
            Plateforme de gestion des assujettis, des notes de perception et d'apurement.
            République Démocratique du Congo.
          </p>
        </div>
        <p className="relative text-xs text-slate-500">© {new Date().getFullYear()} Office National du Tourisme</p>
      </div>

      {/* Right form */}
      <div className="flex w-full items-center justify-center p-6 lg:w-1/2 lg:bg-slate-50">
        <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 shadow-sm">
          <img src="/logo.png" alt="ONT" className="mx-auto mb-4 h-16 w-16 object-contain lg:hidden" />
          <div className="mb-6 flex items-center gap-2 text-slate-800">
            <Lock className="h-5 w-5 text-amber-600" />
            <h2 className="font-heading text-xl font-semibold">Connexion</h2>
          </div>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div className="space-y-1.5">
              <Label htmlFor="email">Adresse email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nom@exemple.cd"
                required
                data-testid="login-email"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                data-testid="login-password"
              />
            </div>
            {error && (
              <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-600" data-testid="login-error">
                {error}
              </p>
            )}
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-slate-900 hover:bg-slate-800"
              data-testid="login-submit"
            >
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Se connecter
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
